'use client';

import React from 'react';

const rows = [
  { label: 'Hours saved per PM / week', value: '10–15 h', ref: 'AppFolio Realm-X baseline' },
  { label: 'Lead-to-lease conversion lift', value: '+50–75 %', ref: 'AppFolio: 73%' },
  { label: 'AP processing time reduction', value: '50–70 %', ref: 'Yardi Virtuoso: 60%' },
  { label: 'Month-end close reduction', value: '70–80 %', ref: 'Yardi: 20h → 5h' },
  { label: 'Maintenance resolution speed', value: '30–50 % faster', ref: 'AppFolio / Yardi data' },
  { label: 'Lease abstraction time', value: '95 %+ reduction', ref: 'JLL: $1M hidden revenue found' },
];

export default function AIMarketReality() {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-6xl mx-auto">
        <div className="reveal-blur mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[rgba(124,58,237,0.25)] mb-5">
            <span className="w-1 h-1 rounded-full bg-[#A78BFA]" />
            <span className="text-[10px] font-mono text-[#A78BFA] tracking-widest uppercase">
              Market Reality · 2025
            </span>
          </div>
          <h2
            className="font-manrope font-extrabold tracking-tighter text-[#EEEEF0]"
            style={{ fontSize: 'clamp(1.75rem, 4vw, 3rem)' }}
          >
            The operators who win the next decade
            <br />
            <span
              style={{
                background: 'linear-gradient(135deg, #7C3AED, #A78BFA)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              won&apos;t be the ones with the best UI.
            </span>
          </h2>
          <p className="mt-4 text-[#9999A8] max-w-2xl leading-relaxed">
            They&apos;ll be the ones whose <span className="text-[#EEEEF0]">agents</span> close the most deals,
            file the fewest tickets, and grow NOI the fastest — without waking anyone up.
          </p>
        </div>

        <div className="bento-card card-shine overflow-hidden reveal-blur">
          <div className="grid grid-cols-12 text-[10px] font-mono text-[#5A5A6E] tracking-widest uppercase px-6 py-3 border-b border-[rgba(255,255,255,0.04)] bg-[rgba(124,58,237,0.04)]">
            <div className="col-span-6">KPI</div>
            <div className="col-span-3 text-right">Target with Propmatic</div>
            <div className="col-span-3 text-right">Industry reference</div>
          </div>
          {rows.map((r, i) => (
            <div
              key={r.label}
              className={`grid grid-cols-12 px-6 py-4 items-center ${
                i !== rows.length - 1 ? 'border-b border-[rgba(255,255,255,0.04)]' : ''
              }`}
            >
              <div className="col-span-6 text-sm text-[#EEEEF0] font-manrope">{r.label}</div>
              <div className="col-span-3 text-right">
                <span
                  className="font-manrope font-bold"
                  style={{
                    background: 'linear-gradient(135deg, #A78BFA, #7C3AED)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  {r.value}
                </span>
              </div>
              <div className="col-span-3 text-right text-[11px] font-mono text-[#5A5A6E]">
                {r.ref}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
